const smsOptOutTypeEnum = Object.freeze({
  LINK: 0,
  REPLY: 1
})

export { smsOptOutTypeEnum }



// WEBPACK FOOTER //
// ./src/modules/settings/enum/SmsOptOutTypeEnum.js